import { environment } from 'src/environments/environment';

interface PhoneNumberConfig {
  baseUrl?: string;
  auditUrl?: string;
}

const wallboards = environment.wallboards as unknown as Record<string, unknown>;
const phoneNumberConfig = wallboards['phoneNumber'] as PhoneNumberConfig | undefined;

export const isPhoneNumberFeatureEnabled = Boolean(phoneNumberConfig?.baseUrl && phoneNumberConfig?.auditUrl);
